
namespace GeniuzPOS.Administration {

    @Serenity.Decorators.registerClass()
    export class UserApprovalRoleGrid extends Serenity.EntityGrid<UserApprovalRoleRow, any> {
        protected getColumnsKey() { return UserApprovalRoleColumns.columnsKey; }
        protected getDialogType() { return UserApprovalRoleDialog; }
        protected getIdProperty() { return UserApprovalRoleRow.idProperty; }
        protected getInsertPermission() { return UserApprovalRoleRow.insertPermission; }
        protected getLocalTextPrefix() { return UserApprovalRoleRow.localTextPrefix; }
        protected getService() { return UserApprovalRoleService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}